import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './core-6f498fd9.js';
import { A as AutoCloseHandler } from './auto-close-handler-253c0ad4.js';
var CsmActionList = /** @class */ (function () {
    function CsmActionList(hostRef) {
        registerInstance(this, hostRef);
        this.disabled = false;
        this.icon = 'more-horizontal';
        this.isOpen = false;
        this.csmOpen = createEvent(this, "csmOpen", 7);
        this.csmClose = createEvent(this, "csmClose", 7);
        this.csmItemClick = createEvent(this, "csmItemClick", 7);
        this.csmDisabledItemClick = createEvent(this, "csmDisabledItemClick", 7);
    }
    CsmActionList.prototype.open = function () {
        this.isOpen = true;
        this.csmOpen.emit(this);
    };
    CsmActionList.prototype.close = function () {
        this.isOpen = false;
        this.csmClose.emit(this);
    };
    CsmActionList.prototype.onItemSelected = function (_event) {
        this.close();
    };
    CsmActionList.prototype.componentDidLoad = function () {
        this.autoCloser = new AutoCloseHandler(this);
    };
    CsmActionList.prototype.componentDidRender = function () {
        var actionList = this.hostElement.shadowRoot.querySelector('csm-dropdown-list');
        if (!actionList) {
            return;
        }
        var hostDimension = this.hostElement.getBoundingClientRect();
        var actionListDimension = actionList.getBoundingClientRect();
        var hasTop = (document.body.clientHeight - actionListDimension.top - actionListDimension.height) >= 0;
        var hasBottom = (document.body.clientHeight - actionListDimension.top - actionListDimension.height) < 0;
        var hasLeft = (document.body.clientWidth - actionListDimension.left - actionListDimension.width) >= 0;
        var hasRight = (document.body.clientWidth - actionListDimension.left - actionListDimension.width) < 0;
        if (hasTop) {
            actionList.style.top = hostDimension.bottom + "px";
        }
        if (hasLeft) {
            actionList.style.left = hostDimension.left + "px";
        }
        if (hasRight) {
            actionList.style.left = hostDimension.left - actionListDimension.width + "px";
        }
        if (hasBottom) {
            actionList.style.top = hostDimension.top - actionListDimension.height + "px";
        }
    };
    CsmActionList.prototype.render = function () {
        var _this = this;
        var dropdown = (h("csm-dropdown-list", { class: "csm-action-list__dropdown-list" }, h("slot", null)));
        return (h(Host, { "data-is-open": this.isOpen }, h("div", { class: "csm-action-list" }, h("csm-button", { icon: this.icon, onCsmClick: function () { return _this.autoCloser.toggle(); }, "text-black": true, class: "csm-action-list__button" }), this.isOpen && dropdown)));
    };
    Object.defineProperty(CsmActionList.prototype, "hostElement", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionList, "style", {
        get: function () { return "\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:400;src:url(../assets/fonts/ProximaNova-Regular.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Regular.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:600;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:700;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:900;src:url(../assets/fonts/ProximaNova-Black.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Black.woff) format(\"woff\")}\@font-face{font-family:CS-FontIcon-v19;src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb);src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb#iefix) format(\"embedded-opentype\"),url(../assets/icons/CS-FontIcon-v19.ttf?cz1hbb) format(\"truetype\"),url(../assets/icons/CS-FontIcon-v19.woff?cz1hbb) format(\"woff\"),url(../assets/icons/CS-FontIcon-v19.svg?cz1hbb#CS-FontIcon-v18) format(\"svg\");font-weight:400;font-style:normal;font-display:block}:root{font-family:Proxima Nova,sans-serif}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:inherit}.csm-action-list__button{display:block;height:32px}.csm-action-list__dropdown-list{position:fixed;z-index:50;margin-left:8px}.fix-overflow csm-dropdown-list{left:calc(100% - 140px)}"; },
        enumerable: true,
        configurable: true
    });
    return CsmActionList;
}());
export { CsmActionList as csm_action_list };
